// frontend/src/utils/auth.js

import { getDemoUser, clearDemoSession } from './mockAuth';

/**
 * Obtiene el rol del usuario actual (modo demo)
 * @returns {Promise<string|null>} El nombre del rol del usuario o null si hay error
 */
export async function getUserRole() {
  const user = getDemoUser();
  return user?.rol?.nombre || null;
}

/**
 * Obtiene los datos completos del usuario actual (modo demo)
 * @returns {Promise<object|null>} Los datos del usuario o null si hay error
 */
export async function getUserData() {
  return getDemoUser();
}

/**
 * Verifica si el usuario tiene un rol específico
 * @param {string} requiredRole - El nombre del rol requerido (COLABORADOR, JEFE, ADMIN)
 * @returns {Promise<boolean>} true si el usuario tiene el rol
 */
export async function hasRole(requiredRole) {
  const role = await getUserRole();
  return role === requiredRole;
}

/**
 * Obtiene el usuario desde localStorage (más rápido, pero puede estar desactualizado)
 * @returns {object} Datos del usuario almacenados localmente
 */
export function getLocalUserData() {
  return {
    userId: localStorage.getItem('userId'),
    userName: localStorage.getItem('userName'),
    userRole: localStorage.getItem('userRole'),
    userRoleId: localStorage.getItem('userRoleId'),
    userEmail: localStorage.getItem('userEmail'),
  };
}

/**
 * Limpia los datos del usuario del localStorage
 */
export function clearLocalUserData() {
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  localStorage.removeItem('userRole');
  localStorage.removeItem('userRoleId');
  localStorage.removeItem('userEmail');
}

/**
 * Cierra sesión del usuario (modo demo)
 * @returns {Promise<void>}
 */
export async function logout() {
  clearDemoSession();
  clearLocalUserData();
}
